import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import LinearProgress from '@material-ui/core/LinearProgress';

import {sessionState} from 'session/session-state.js';
import {sloppyReportAPI} from 'api/sloppy-report.js';
import {ErrorUtil} from 'utils/error-util.js';
import {ViewMode} from 'models/view-mode.js';

import {FarmSelect} from 'components/FarmSelect.js';
import {ReturnButton} from 'components/ReturnButton.js';
import {UClipsInputForm} from 'screens/UClipsScreen/input.jsx';
import {SimpleTable} from 'components/tables/SimpleTable.js';
import {ErrorMessage} from 'components/ErrorMessage.js';
import {GlobalCss} from 'components/global-css.js';

const styles = {
  flexContainer: GlobalCss.flexContainer,
  leftJustifiedIitem: GlobalCss.leftJustifiedIitem,
  rightJustifiedIitem: GlobalCss.rightJustifiedIitem,
  readonlyText: GlobalCss.readonlyText,
};

class UClipsEditScreen extends React.Component {
  constructor(props) {
    super();

    const farm = sessionState.currentFarm();

    this.state = {
      record: {
        name: '',
        sql: ''
      },
      loaded: false,
      showProgress: false,
      showDialog: false
    };

    this.farmId = sessionState.currentFarmId();

    const params = props.match.params;
    this.id = params.id ? parseInt(params.id, 10) : null;
    this.viewMode = new ViewMode(params.action);

    this.title = `UClips - ${this.viewMode.label}`;
    this.notification = `${this.viewMode.label}が完了しました`;
    this.buttonColor = this.viewMode.isDelete() ? 'secondary' : 'primary';
    this.disableFeedLogicSwitchingDate = farm.isUMLight();
  }

  componentDidMount() {
    if (this.viewMode.isCreate()) {
      this.setState({
        loaded: true
      });
      return;
    }

    this.show();
  }

  show() {
    this.setState({showProgress: true});

    return sloppyReportAPI.show(this.farmId, this.id).then((res) => {
      const record = Object.assign({}, res.data);

      this.setState({
        record: record,
        loaded: true,
        showProgress: false
      });
    });
  }

  returnAction() {
    this.props.history.push('/u_clips');
  }

  syncState(key, value) {
    const input = this.state.input || {...this.state.record};
    input[key] = value;
    this.setState({input: input});
  }

  validate() {
    if (this.viewMode.isDelete()) {
      return {valid: true};
    }

    const input = this.state.input;
    const errors = [];

    if (!input) {
      errors.push('内容が変更されていません');
      return {valid: false, errors: errors};
    }

    if (!input.name) {
      errors.push('設定名が入力されていません');
    }

    if (!input.sql) {
      errors.push('SQLが入力されていません');
    }

    return {valid: errors.length === 0, errors: errors};
  }

  save() {
    const result = this.validate();
    if (!result.valid) {
      this.setState({errorMessage: result.errors.join('\n')});
      return;
    } else {
      this.setState({errorMessage: ''});
    }

    let action;
    if (this.viewMode.isCreate()) {
      action = sloppyReportAPI.create(this.farmId, this.createParams());
    } else if (this.viewMode.isUpdate()) {
      action = sloppyReportAPI.update(this.farmId, this.id, this.createParams());
    } else if (this.viewMode.isDelete()) {
      action = sloppyReportAPI.delete(this.farmId, this.id);
    }

    this.setState({showProgress: true});

    action.then((res) => {
      this.setState({showDialog: true, showProgress: false});
      setTimeout(() => {
        this.setState({showDialog: false});
        this.returnAction();
      }, 1000);
    }).catch((error) => {
      this.setState({showProgress: false});
      const errorMessage = ErrorUtil.generateMessage(error);
      this.setState({errorMessage: errorMessage});
      console.error(errorMessage);
    });
  }

  createParams() {
    const input = this.state.input;
    return {
      name: input.name,
      sql: input.sql
    };
  }

  confirmSql() {
    this.setState({errorMessage: ''});

    const input = this.state.input || {...this.state.record};
    if (!input.sql) {
      this.setState({errorMessage: 'SQLが入力されていません'});
      return;
    }

    this.setState({showProgress: true});

    sloppyReportAPI.confirmSql(this.farmId, input.sql).then((res) => {
      const columns = res.data.columns.map((columnId) => {
        return {id: columnId, label: columnId};
      });

      const sqlResult = {columns: columns, records: res.data.rows};

      this.setState({
        sqlResult: sqlResult,
        loaded: true,
        showProgress: false,
        errorMessage: ''
      });
    }).catch((error) => {
      this.setState({showProgress: false});
      const errorMessage = ErrorUtil.generateMessage(error);
      this.setState({errorMessage: errorMessage});
      console.error(errorMessage);
    });
  }

  render() {
    const classes = this.props.classes;

    return (
      <div style={{marginLeft: 20}}>
        <h2>{this.title}</h2>

        <ul className={classes.flexContainer}>
          <li>
            <ReturnButton returnAction={() => this.returnAction()} />
          </li>

          <li style={{marginLeft: 470}}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => this.confirmSql()}
            >
              SQLの結果確認
            </Button>
          </li>

          <li style={{marginLeft: 30}}>
            <Button
              variant="contained"
              color={this.buttonColor}
              onClick={() => this.save()}
              disabled={this.state.showProgress}>
              {this.viewMode.label}
            </Button>
          </li>
        </ul>

        <div style={{marginLeft: '40px'}}>
          <ErrorMessage errorMessage={this.state.errorMessage} />
        </div>

        <div style={{width: 300, marginBottom: 10, marginLeft: 200}}>
          {this.state.showProgress ? <LinearProgress /> : null}
        </div>

        <FarmSelect changeAction={() => {}} isDisabled={true} />

        <Dialog
          open={this.state.showDialog}
          onClose={() => this.setState({showDialog: false})}
          TransitionComponent={Slide}
          aria-labelledby="notification-dialog"
        >
          <DialogTitle id="notification-dialog">{this.notification}</DialogTitle>
        </Dialog>

        <DetailForm
          loaded={this.state.loaded}
          record={this.state.record}
          viewMode={this.viewMode}
          syncState={this.syncState.bind(this)}
          classes={classes}
          disableFeedLogicSwitchingDate={this.disableFeedLogicSwitchingDate}
        />

        { this.state.sqlResult ?
          <SimpleTable
            records={this.state.sqlResult.records}
            columns={this.state.sqlResult.columns}
          /> : null
        }
      </div>
    );
  }
}

UClipsEditScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const forExport = withRouter(withStyles(styles)(UClipsEditScreen));
export {forExport as UClipsEditScreen};

const DetailForm = (props) => {
  if (props.loaded) {
    if (props.viewMode.isDelete()) {
      return (
        <DeleteForm classes={props.classes} record={props.record} />
      );
    } else {
      return (
        <UClipsInputForm
          record={props.record}
          syncState={props.syncState}
        />
      );
    }
  } else {
    return null;
  }
};

DetailForm.propTypes = {
  classes: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired
};

const DeleteForm = (props) => {
  const classes = props.classes;
  const record = props.record;
  return (
    <div style={{marginLeft: '100px'}}>
      <TextField
        type="text"
        placeholder=""
        label="設定名"
        value={record.name}
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
        margin="none"
        className={classes.readonlyText}
      />
    </div>
  );
};

DeleteForm.propTypes = {
  classes: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired
};
